import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ButtonLoading from 'shared/ButtonLoading';
import Translation from "./Translation";

class Button extends Component {
    render() {
        return(
            <button onClick={this.props.onClick} className={this.props.className} disabled={this.props.disabled || this.props.loading}>
                {this.getContent()}
            </button>
        )
    }
    getContent = () => {
        if(this.props.loading) {
            return <ButtonLoading>{this.props.loadingText}</ButtonLoading>
        } else {
            return this.props.children;
        }
    }
}

Button.propTypes = {
    onClick: PropTypes.func.isRequired,
    className: PropTypes.string,
    loading: PropTypes.bool,
    disabled: PropTypes.bool,
    loadingText: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.object
    ])
}

Button.defaultProps = {
  loadingText: <Translation>{"checkout__loading"}</Translation>
}

export default Button;
